import React from 'react';

import { CmButton, CmFlex } from '@/components/uiParts';
import { CmBackLink } from '@/components/uiParts/Link/CmBackLink ';
import {
  BUTTON_AREA_ID,
  ListUrl,
} from '@/pages/menu-managements/components/TopButtonArea';

type Props = {
  listUrl: ListUrl;
  isDisabledSubmitButton: boolean;
  handleCreate: () => void;
};

export const MenuManagementNewButtonArea: React.FC<Props> = ({
  listUrl,
  isDisabledSubmitButton,
  handleCreate,
}): JSX.Element => {
  return (
    <CmFlex
      id={BUTTON_AREA_ID}
      padding="20px 20px 20px 0"
      alignItems="center"
      justifyContent="space-between"
    >
      <CmBackLink to={listUrl}>一覧へ戻る</CmBackLink>
      {/*
       // @ts-ignore TS2590 */}
      <CmButton onClick={handleCreate} isDisabled={isDisabledSubmitButton}>
        登録
      </CmButton>
    </CmFlex>
  );
};
